// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import styled, { keyframes } from 'styled-components';

const slideIn = keyframes`
    0% { left: -50%; }
    100% { left: 5%;  }
`
const Hamburger = styled.div`
    position: relative;
    height: 50px;
    width: 50px;
    top: 50%;
    transform: translateY(-50%);

    z-index: 1000;
    cursor: pointer;
    border-radius: 50%;
    transition: all 0.2s ease-in-out;
    background: rgba(255, 255, 255, 0.2);

    animation: ${slideIn};
    animation-duration: 1s;
    animation-fill-mode: forwards;

    display: flex;
    align-items: center;
    justify-content: center;

    user-select: none;

    &:active {
        // transform: scale(1.1);
        box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
    }
`
const Line = styled.div`
    position: absolute;
    width: 55%;
    height: 3px;
    background-color: black;
    transition: all 400ms cubic-bezier(.84, .06, .52, 1.8);
    border-radius: 2rem;
`
const LineA = styled(Line)`
    transform: translateY(-8px);
    animation-delay: 100ms;
    ${({ open }) => open && 'transform: rotate(45deg);'}
`
const LineB = styled(Line)`
    ${({ open }) => open && 'transform: rotate(-45deg);'}
`
const LineC = styled(Line)`
    transform: translateY(8px);
    animation-delay: 250ms;
    ${({ open }) => open && `
        opacity: 0;
        transform: translate(-50px, 8px);
    `}
`

const BurgerIcon = ({ open, updateOpenState, ...props }) => {
    return (
        <Hamburger onClick={() => updateOpenState(!open)} {...props}>
            <LineA open={open} />
            <LineB open={open} />
            <LineC open={open} />
        </Hamburger>
    );
}

export default BurgerIcon;